<div class="avi-content-loading-wrapper">
    <div class="avi-content-loading-wrapper__spinner">
        <clr-spinner
            *ngIf="isLoading"
            [clrMedium]="isSpinnerMedium"
            [clrSmall]="isSpinnerSmall"
        ></clr-spinner>
    </div>
    <div [style]="isLoading ? 'opacity: 0.5; pointer-events: none' : null">
        <ng-content></ng-content>
    </div>
</div>
